// 测试环境
export default {
    timeFormate(timeStamp) {
        let year = new Date(timeStamp).getFullYear();
        let month = new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
        let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
        let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
        let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
        let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
        return year + "-" + month + "-" + date + " " + hh + ":" + mm + ":" + ss;
        // return nowTime = year + "-" + month + "-" + date + "-" + " " + hh + ":" + mm+":"+ss;

    },
    GettimeStamp(timeStamp) {
        let year = new Date(timeStamp).getFullYear();
        let month = new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
        let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
        let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
        let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
        let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
        let ml = new Date(timeStamp).getMilliseconds() < 10 ? "0" + new Date(timeStamp).getMilliseconds() : new Date(timeStamp).getMilliseconds();
        return "" + year + month + date + hh + mm + ss + ml;
        // return nowTime = year + "-" + month + "-" + date + "-" + " " + hh + ":" + mm+":"+ss;

    },
    // 定时器函数
    getNowStr() {
        return this.timeFormate(new Date());
    },
    getCurrentYearStr(timeStamp) {
        return new Date(timeStamp).getFullYear();
    },
    getCurrentMonthStr(timeStamp) {
        return new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
    },
    getCurrentDayStr(timeStamp) {
        return new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
    },
    number_chinese(str) {
        var num = parseFloat(str);
        var strOutput = "",
            strUnit = '仟佰拾亿仟佰拾万仟佰拾元角分';
        num += "00";
        var intPos = num.indexOf('.');
        if (intPos >= 0) {
            num = num.substring(0, intPos) + num.substr(intPos + 1, 2);
        }
        strUnit = strUnit.substr(strUnit.length - num.length);
        for (var i = 0; i < num.length; i++) {
            strOutput += '零壹贰叁肆伍陆柒捌玖'.substr(num.substr(i, 1), 1) + strUnit.substr(i, 1);
        }
        return strOutput.replace(/零角零分$/, '整').replace(/零[仟佰拾]/g, '零').replace(/零{2,}/g, '零').replace(/零([亿|万])/g, '$1').replace(/零+元/, '元').replace(/亿零{0,3}万/, '亿').replace(/^元/, "零元")

    },
    // 判断是否为手机号
    isPhoneAvailable: function(pone) {
        var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
        if (!myreg.test(pone)) {
            return false;
        } else {
            return true;
        }
    },
    /**
     * 判断是否为电话号码
     * @param {String } tel 电话号码
     */
    isTelAvailable: function(tel) {
        var myreg = /^(([0\+]\d{2,3}-)?(0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/;
        if (!myreg.test(tel)) {
            return false;
        } else {
            return true;
        }
    },
    /**
     * 验证是否为联系方式
     * @param {String} tel 联系方式
     */
    isContactWay: function(tel) {
        if (this.isTelAvailable(tel) || this.isPhoneAvailable(tel)) {
            return true;
        } else {
            return false;

        }
    },
    /**
     * 判断是否为字母和数字组成
     * @param {String} str 字符串 
     */
    isNumberAndletter: function(str) {

        var reg1 = new RegExp(/^[0-9A-Za-z]+$/);
        if (!reg1.test(str)) {
            return false;
        }
        // var reg = new RegExp(/[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/);
        // if (reg.test(str)) {
        //     return true;
        // } else {
        //     return false;
        // }
        return true;
    },
     checkSpecificKey1(str) {
        var specialKey =
          "[`~!#$^&*=|{}':;',\\[\\].<>/?~！#￥……&*——|{}【】‘；：”“'。，、？]‘'";
        for (var i = 0; i < str.length; i++) {
          if (specialKey.indexOf(str.substr(i, 1)) != -1) {
            //   debugger;
            return false;
          }
        }
        return true;
      },
    getUrl() {
       return "https://img.gbbh.cn/";
     },
     getTZUrl() {
        return "http://xa.gbbh.net.cn/#/"               // 测试服务器2

      },
      getName(){
       return "工保保函（北京）科技有限公司"
    },
    getICP(){
      return "19055464号-7"
          //return "19055464号-1"
    }
};


// WEBPACK FOOTER //
// ./src/utils/utils.js